export default function () {
  return [
    {
      title: '阶段(里程碑)',
      isEdit: true,
      [$field]: 'phaseName',
      props: {
        maxlength: 500
      }
    },
    {
      title: '标记完成度',
      isEdit: true,
      [$field]: 'markingCompletionRate',
      showType: 'numberInput',
      textRender: (item) => {
        return `${item.markingCompletionRate}%`
      }
    },
    {
      showType: 'datePicker',
      title: '计划完成日期',
      isEdit: true,
      props: {
        type: 'date'
      },
      [$field]: 'plannedCompletionDate'
    },
    {
      showType: 'datePicker',
      title: '实际完成日期',
      isEdit: true,
      props: {
        type: 'date'
      },
      [$field]: 'actualCompletionDate'
    },
    {
      title: '操作',
      width: 120,
      [$field]: 'operate',
      isOperate: true
    }
  ]
}
